import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { APIService } from 'src/app/services/APIService';
import { LocalUtilService } from 'src/app/services/local-util.service';

@Component({
    selector: 'app-admin-centri-di-selezione',
    templateUrl: './centri-di-selezione.component.html',
    styleUrls: ['./centri-di-selezione.component.css'],
    standalone: false
})
export class AdminCentriDiSelezioneComponent extends APIService {

  constructor(public localService: LocalUtilService,
    location: Location, 
    router: Router, translateService: TranslateService) {
    super(localService, location, router, translateService);
  }

}

